import { render, staticRenderFns } from "./Finalize2.vue?vue&type=template&id=4ca6ee96&"
import script from "./Finalize2.vue?vue&type=script&lang=js&"
export * from "./Finalize2.vue?vue&type=script&lang=js&"
import style0 from "./Finalize2.vue?vue&type=style&index=0&id=4ca6ee96&prod&lang=scss&scoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports